import { z } from 'zod';

/**
 * Mark backfill accessories requested form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(markBackfillAccessoriesRequestedFormSchema)
 */
const markBackfillAccessoriesRequestedFormSchema = z.object({
    isConfirmed: z.boolean().refine((val) => val === true, {
        message: 'Please confirm backfill accessories have been requested',
    }),
});
/**
 * Mark backfill accessories received form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(markBackfillAccessoriesReceivedFormSchema)
 */
const markBackfillAccessoriesReceivedFormSchema = z.object({
    isConfirmed: z.boolean().refine((val) => val === true, {
        message: 'Please confirm backfill accessories have been received',
    }),
});
/**
 * Mark backfill accessories installed form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(markBackfillAccessoriesInstalledFormSchema)
 */
const markBackfillAccessoriesInstalledFormSchema = z.object({
    isConfirmed: z.boolean().refine((val) => val === true, {
        message: 'Please confirm backfill accessories have been installed',
    }),
});

export { markBackfillAccessoriesInstalledFormSchema, markBackfillAccessoriesReceivedFormSchema, markBackfillAccessoriesRequestedFormSchema };
//# sourceMappingURL=accessoriesValidation.js.map
